import { IconIdentifier, Pill, PillVariant } from '@aus-platform/design-system';
import {
  DatasetAssetTypeWithBaseData,
  GCPType,
  GCPTypeLabel,
  ProcessingStagesValue,
} from './enums';
import { GeotagSchemaField, ProcessingStatus } from 'src/shared/enums';
import { EPSGCode, HorizontalCRS, VerticalCRS } from 'src/shared/enums/crs';
import type { EndProcessingSelectOption } from './types';

export const InputHorizontalCRSOptions = [
  {
    label: 'WGS 84',
    value: EPSGCode.WGS84,
  },

  // WGS 84 / UTM Northern Hemisphere.
  {
    label: 'WGS 84 / UTM zone 19N',
    value: EPSGCode.WGS84_UTM_ZONE_19N,
  },
  {
    label: 'WGS 84 / UTM zone 42N',
    value: EPSGCode.WGS84_UTM_ZONE_42,
  },
  {
    label: 'WGS 84 / UTM zone 43N',
    value: EPSGCode.WGS84_UTM_ZONE_43,
  },
  {
    label: 'WGS 84 / UTM zone 44N',
    value: EPSGCode.WGS84_UTM_ZONE_44,
  },
  {
    label: 'WGS 84 / UTM zone 45N',
    value: EPSGCode.WGS84_UTM_ZONE_45,
  },
  {
    label: 'WGS 84 / UTM zone 46N',
    value: EPSGCode.WGS84_UTM_ZONE_46,
  },
  {
    label: 'WGS 84 / UTM zone 47N',
    value: EPSGCode.WGS84_UTM_ZONE_47,
  },
  {
    label: 'WGS 84 / UTM zone 48N',
    value: EPSGCode.WGS84_UTM_ZONE_48,
  },
  {
    label: 'WGS 84 / UTM zone 49N',
    value: EPSGCode.WGS84_UTM_ZONE_49,
  },
  {
    label: 'WGS 84 / UTM zone 50N',
    value: EPSGCode.WGS84_UTM_ZONE_50N,
  },
  {
    label: 'WGS 84 / UTM zone 51N',
    value: EPSGCode.WGS84_UTM_ZONE_51N,
  },
  {
    label: 'WGS 84 / UTM zone 52N',
    value: EPSGCode.WGS84_UTM_ZONE_52N,
  },
  {
    label: 'WGS 84 / UTM zone 53N',
    value: EPSGCode.WGS84_UTM_ZONE_53N,
  },
  {
    label: 'WGS 84 / UTM zone 54N',
    value: EPSGCode.WGS84_UTM_ZONE_54N,
  },

  // WGS 84 / UTM Southern Hemisphere.
  {
    label: 'WGS 84 / UTM zone 18S',
    value: EPSGCode.WGS84_UTM_ZONE_18S,
  },
  {
    label: 'WGS 84 / UTM zone 19S',
    value: EPSGCode.WGS84_UTM_ZONE_19S,
  },
  {
    label: 'WGS 84 / UTM zone 20S',
    value: EPSGCode.WGS84_UTM_ZONE_20S,
  },
  {
    label: 'WGS 84 / UTM zone 21S',
    value: EPSGCode.WGS84_UTM_ZONE_21S,
  },
  {
    label: 'WGS 84 / UTM zone 22S',
    value: EPSGCode.WGS84_UTM_ZONE_22S,
  },
  {
    label: 'WGS 84 / UTM zone 23S',
    value: EPSGCode.WGS84_UTM_ZONE_23S,
  },
  {
    label: 'WGS 84 / UTM zone 24S',
    value: EPSGCode.WGS84_UTM_ZONE_24S,
  },
  {
    label: 'WGS 84 / UTM zone 25S',
    value: EPSGCode.WGS84_UTM_ZONE_25S,
  },
  {
    label: 'WGS 84 / UTM zone 46S',
    value: EPSGCode.WGS84_UTM_ZONE_46S,
  },
  {
    label: 'WGS 84 / UTM zone 47S',
    value: EPSGCode.WGS84_UTM_ZONE_47S,
  },
  {
    label: 'WGS 84 / UTM zone 48S',
    value: EPSGCode.WGS84_UTM_ZONE_48S,
  },
  {
    label: 'WGS 84 / UTM zone 49S',
    value: EPSGCode.WGS84_UTM_ZONE_49S,
  },
  {
    label: 'WGS 84 / UTM zone 50S',
    value: EPSGCode.WGS84_UTM_ZONE_50S,
  },
  {
    label: 'WGS 84 / UTM zone 51S',
    value: EPSGCode.WGS84_UTM_ZONE_51S,
  },
  {
    label: 'WGS 84 / UTM zone 52S',
    value: EPSGCode.WGS84_UTM_ZONE_52S,
  },
  {
    label: 'WGS 84 / UTM zone 53S',
    value: EPSGCode.WGS84_UTM_ZONE_53S,
  },
  {
    label: 'WGS 84 / UTM zone 54S',
    value: EPSGCode.WGS84_UTM_ZONE_54S,
  },

  // GDA2020 / MGA zones.
  {
    label: 'GDA2020 / MGA zone 46',
    value: EPSGCode.GDA2020_MGA_ZONE_46,
  },
  {
    label: 'GDA2020 / MGA zone 47',
    value: EPSGCode.GDA2020_MGA_ZONE_47,
  },
  {
    label: 'GDA2020 / MGA zone 48',
    value: EPSGCode.GDA2020_MGA_ZONE_48,
  },
  {
    label: 'GDA2020 / MGA zone 49',
    value: EPSGCode.GDA2020_MGA_ZONE_49,
  },
  {
    label: 'GDA2020 / MGA zone 50',
    value: EPSGCode.GDA2020_MGA_ZONE_50,
  },
  {
    label: 'GDA2020 / MGA zone 51',
    value: EPSGCode.GDA2020_MGA_ZONE_51,
  },
  {
    label: 'GDA2020 / MGA zone 52',
    value: EPSGCode.GDA2020_MGA_ZONE_52,
  },
  {
    label: 'GDA2020 / MGA zone 53',
    value: EPSGCode.GDA2020_MGA_ZONE_53,
  },
  {
    label: 'GDA2020 / MGA zone 54',
    value: EPSGCode.GDA2020_MGA_ZONE_54,
  },
  {
    label: 'GDA2020 / MGA zone 55',
    value: EPSGCode.GDA2020_MGA_ZONE_55,
  },
  {
    label: 'GDA2020 / MGA zone 56',
    value: EPSGCode.GDA2020_MGA_ZONE_56,
  },
  {
    label: 'GDA2020 / MGA zone 57',
    value: EPSGCode.GDA2020_MGA_ZONE_57,
  },
  {
    label: 'GDA2020 / MGA zone 58',
    value: EPSGCode.GDA2020_MGA_ZONE_58,
  },

  // GDA94 / MGA zones.
  {
    label: 'GDA94 / MGA zone 46',
    value: EPSGCode.GDA94_MGA_ZONE_46,
  },
  {
    label: 'GDA94 / MGA zone 47',
    value: EPSGCode.GDA94_MGA_ZONE_47,
  },
  {
    label: 'GDA94 / MGA zone 48',
    value: EPSGCode.GDA94_MGA_ZONE_48,
  },
  {
    label: 'GDA94 / MGA zone 49',
    value: EPSGCode.GDA94_MGA_ZONE_49,
  },
  {
    label: 'GDA94 / MGA zone 50',
    value: EPSGCode.GDA94_MGA_ZONE_50,
  },
  {
    label: 'GDA94 / MGA zone 51',
    value: EPSGCode.GDA94_MGA_ZONE_51,
  },
  {
    label: 'GDA94 / MGA zone 52',
    value: EPSGCode.GDA94_MGA_ZONE_52,
  },
  {
    label: 'GDA94 / MGA zone 53',
    value: EPSGCode.GDA94_MGA_ZONE_53,
  },
  {
    label: 'GDA94 / MGA zone 54',
    value: EPSGCode.GDA94_MGA_ZONE_54,
  },
  {
    label: 'GDA94 / MGA zone 55',
    value: EPSGCode.GDA94_MGA_ZONE_55,
  },
  {
    label: 'GDA94 / MGA zone 56',
    value: EPSGCode.GDA94_MGA_ZONE_56,
  },
  {
    label: 'GDA94 / MGA zone 57',
    value: EPSGCode.GDA94_MGA_ZONE_57,
  },
  {
    label: 'GDA94 / MGA zone 58',
    value: EPSGCode.GDA94_MGA_ZONE_58,
  },

  // Other CRSs.
  {
    label: 'Arc 1950 / UTM zone 35S',
    value: EPSGCode.ARC_1950_UTM_ZONE_35S,
  },
  {
    label: 'GGRS87 / Greek Grid',
    value: EPSGCode.GGRS87_GREEK_GRID,
  },
  {
    label: 'NAD83(2011) / Wisconsin South (ftUS)',
    value: EPSGCode.NAD83_2011_WISCONSIN_SOUTH_FTUS,
  },
  {
    label: 'NAD83(CSRS) / UTM zone 19N',
    value: EPSGCode.NAD83_CSRS_UTM_ZONE_19N,
  },
  {
    label: 'SIRGAS 2000 / UTM zone 14N',
    value: EPSGCode.SIRGAS_2000_UTM_ZONE_14N,
  },
  {
    label: 'SIRGAS 2000 / UTM zone 23S',
    value: EPSGCode.SIRGAS_2000_UTM_ZONE_23S,
  },
  {
    label: 'SIRGAS 2000 / UTM zone 24S',
    value: EPSGCode.SIRGAS_2000_UTM_ZONE_24S,
  },
  {
    label: 'TUREF / TM27',
    value: EPSGCode.TUREF_TM27,
  },
];

export const InputVerticalCRSOptions = [
  {
    label: 'Ellipsoidal',
    value: VerticalCRS.ELLIPSOIDAL,
  },
  {
    label: 'EGM96',
    value: VerticalCRS.EGM96,
  },
  {
    label: 'EGM2008',
    value: VerticalCRS.EGM2008,
  },
  {
    label: 'AHD71',
    value: VerticalCRS.AHD71,
  },
  {
    label: 'CGVD2013',
    value: VerticalCRS.CGVD2013,
  },
  {
    label: 'Baltic 1957',
    value: VerticalCRS.BALTIC_1957,
  },
  {
    label: 'Baltic 1977',
    value: VerticalCRS.BALTIC_1977,
  },
  {
    label: 'Baltic 1982',
    value: VerticalCRS.BALTIC_1982,
  },
  {
    label: 'Baltic 1986',
    value: VerticalCRS.BALTIC_1986,
  },
  {
    label: 'INAGEOID2020',
    value: VerticalCRS.INAGEOID_2020,
  },
  {
    label: 'MAPGEO2015',
    value: VerticalCRS.MAPGEO2015,
  },
  {
    label: 'IMBITUBA',
    value: VerticalCRS.IMBITUBA,
  },
];

export const OutputHorizontalCRSOptions = [
  {
    label: 'WGS 84',
    value: EPSGCode.WGS84,
  },
  // WGS84 / UTM Northern Hemisphere
  {
    label: 'WGS 84 / UTM zone 19N',
    value: EPSGCode.WGS84_UTM_ZONE_19N,
  },
  {
    label: 'WGS 84 / UTM zone 42N',
    value: EPSGCode.WGS84_UTM_ZONE_42,
  },
  {
    label: 'WGS 84 / UTM zone 43N',
    value: EPSGCode.WGS84_UTM_ZONE_43,
  },
  {
    label: 'WGS 84 / UTM zone 44N',
    value: EPSGCode.WGS84_UTM_ZONE_44,
  },
  {
    label: 'WGS 84 / UTM zone 45N',
    value: EPSGCode.WGS84_UTM_ZONE_45,
  },
  {
    label: 'WGS 84 / UTM zone 46N',
    value: EPSGCode.WGS84_UTM_ZONE_46,
  },
  {
    label: 'WGS 84 / UTM zone 47N',
    value: EPSGCode.WGS84_UTM_ZONE_47,
  },
  {
    label: 'WGS 84 / UTM zone 48N',
    value: EPSGCode.WGS84_UTM_ZONE_48,
  },
  {
    label: 'WGS 84 / UTM zone 49N',
    value: EPSGCode.WGS84_UTM_ZONE_49,
  },
  {
    label: 'WGS 84 / UTM zone 50N',
    value: EPSGCode.WGS84_UTM_ZONE_50N,
  },
  {
    label: 'WGS 84 / UTM zone 51N',
    value: EPSGCode.WGS84_UTM_ZONE_51N,
  },
  {
    label: 'WGS 84 / UTM zone 52N',
    value: EPSGCode.WGS84_UTM_ZONE_52N,
  },
  {
    label: 'WGS 84 / UTM zone 53N',
    value: EPSGCode.WGS84_UTM_ZONE_53N,
  },
  {
    label: 'WGS 84 / UTM zone 54N',
    value: EPSGCode.WGS84_UTM_ZONE_54N,
  },
  // WGS84 / UTM Southern Hemisphere
  {
    label: 'WGS 84 / UTM zone 18S',
    value: EPSGCode.WGS84_UTM_ZONE_18S,
  },
  {
    label: 'WGS 84 / UTM zone 19S',
    value: EPSGCode.WGS84_UTM_ZONE_19S,
  },
  {
    label: 'WGS 84 / UTM zone 20S',
    value: EPSGCode.WGS84_UTM_ZONE_20S,
  },
  {
    label: 'WGS 84 / UTM zone 21S',
    value: EPSGCode.WGS84_UTM_ZONE_21S,
  },
  {
    label: 'WGS 84 / UTM zone 22S',
    value: EPSGCode.WGS84_UTM_ZONE_22S,
  },
  {
    label: 'WGS 84 / UTM zone 23S',
    value: EPSGCode.WGS84_UTM_ZONE_23S,
  },
  {
    label: 'WGS 84 / UTM zone 24S',
    value: EPSGCode.WGS84_UTM_ZONE_24S,
  },
  {
    label: 'WGS 84 / UTM zone 25S',
    value: EPSGCode.WGS84_UTM_ZONE_25S,
  },
  {
    label: 'WGS 84 / UTM zone 46S',
    value: EPSGCode.WGS84_UTM_ZONE_46S,
  },
  {
    label: 'WGS 84 / UTM zone 47S',
    value: EPSGCode.WGS84_UTM_ZONE_47S,
  },
  {
    label: 'WGS 84 / UTM zone 48S',
    value: EPSGCode.WGS84_UTM_ZONE_48S,
  },
  {
    label: 'WGS 84 / UTM zone 49S',
    value: EPSGCode.WGS84_UTM_ZONE_49S,
  },
  {
    label: 'WGS 84 / UTM zone 50S',
    value: EPSGCode.WGS84_UTM_ZONE_50S,
  },
  {
    label: 'WGS 84 / UTM zone 51S',
    value: EPSGCode.WGS84_UTM_ZONE_51S,
  },
  {
    label: 'WGS 84 / UTM zone 52S',
    value: EPSGCode.WGS84_UTM_ZONE_52S,
  },
  {
    label: 'WGS 84 / UTM zone 53S',
    value: EPSGCode.WGS84_UTM_ZONE_53S,
  },
  {
    label: 'WGS 84 / UTM zone 54S',
    value: EPSGCode.WGS84_UTM_ZONE_54S,
  },
  // GDA2020 / MGA zones
  {
    label: 'GDA2020 / MGA zone 46',
    value: EPSGCode.GDA2020_MGA_ZONE_46,
  },
  {
    label: 'GDA2020 / MGA zone 47',
    value: EPSGCode.GDA2020_MGA_ZONE_47,
  },
  {
    label: 'GDA2020 / MGA zone 48',
    value: EPSGCode.GDA2020_MGA_ZONE_48,
  },
  {
    label: 'GDA2020 / MGA zone 49',
    value: EPSGCode.GDA2020_MGA_ZONE_49,
  },
  {
    label: 'GDA2020 / MGA zone 50',
    value: EPSGCode.GDA2020_MGA_ZONE_50,
  },
  {
    label: 'GDA2020 / MGA zone 51',
    value: EPSGCode.GDA2020_MGA_ZONE_51,
  },
  {
    label: 'GDA2020 / MGA zone 52',
    value: EPSGCode.GDA2020_MGA_ZONE_52,
  },
  {
    label: 'GDA2020 / MGA zone 53',
    value: EPSGCode.GDA2020_MGA_ZONE_53,
  },
  {
    label: 'GDA2020 / MGA zone 54',
    value: EPSGCode.GDA2020_MGA_ZONE_54,
  },
  {
    label: 'GDA2020 / MGA zone 55',
    value: EPSGCode.GDA2020_MGA_ZONE_55,
  },
  {
    label: 'GDA2020 / MGA zone 56',
    value: EPSGCode.GDA2020_MGA_ZONE_56,
  },
  {
    label: 'GDA2020 / MGA zone 57',
    value: EPSGCode.GDA2020_MGA_ZONE_57,
  },
  {
    label: 'GDA2020 / MGA zone 58',
    value: EPSGCode.GDA2020_MGA_ZONE_58,
  },
  // GDA94 / MGA zones
  {
    label: 'GDA94 / MGA zone 46',
    value: EPSGCode.GDA94_MGA_ZONE_46,
  },
  {
    label: 'GDA94 / MGA zone 47',
    value: EPSGCode.GDA94_MGA_ZONE_47,
  },
  {
    label: 'GDA94 / MGA zone 48',
    value: EPSGCode.GDA94_MGA_ZONE_48,
  },
  {
    label: 'GDA94 / MGA zone 49',
    value: EPSGCode.GDA94_MGA_ZONE_49,
  },
  {
    label: 'GDA94 / MGA zone 50',
    value: EPSGCode.GDA94_MGA_ZONE_50,
  },
  {
    label: 'GDA94 / MGA zone 51',
    value: EPSGCode.GDA94_MGA_ZONE_51,
  },
  {
    label: 'GDA94 / MGA zone 52',
    value: EPSGCode.GDA94_MGA_ZONE_52,
  },
  {
    label: 'GDA94 / MGA zone 53',
    value: EPSGCode.GDA94_MGA_ZONE_53,
  },
  {
    label: 'GDA94 / MGA zone 54',
    value: EPSGCode.GDA94_MGA_ZONE_54,
  },
  {
    label: 'GDA94 / MGA zone 55',
    value: EPSGCode.GDA94_MGA_ZONE_55,
  },
  {
    label: 'GDA94 / MGA zone 56',
    value: EPSGCode.GDA94_MGA_ZONE_56,
  },
  {
    label: 'GDA94 / MGA zone 57',
    value: EPSGCode.GDA94_MGA_ZONE_57,
  },
  {
    label: 'GDA94 / MGA zone 58',
    value: EPSGCode.GDA94_MGA_ZONE_58,
  },
  // Other CRS
  {
    label: 'Arc 1950 / UTM zone 35S',
    value: EPSGCode.ARC_1950_UTM_ZONE_35S,
  },
  {
    label: 'GGRS87 / Greek Grid',
    value: EPSGCode.GGRS87_GREEK_GRID,
  },
  {
    label: 'NAD83(2011) / Wisconsin South (ftUS)',
    value: EPSGCode.NAD83_2011_WISCONSIN_SOUTH_FTUS,
  },
  {
    label: 'NAD83(CSRS) / UTM zone 19N',
    value: EPSGCode.NAD83_CSRS_UTM_ZONE_19N,
  },
  {
    label: 'SIRGAS 2000 / UTM zone 14N',
    value: EPSGCode.SIRGAS_2000_UTM_ZONE_14N,
  },
  {
    label: 'SIRGAS 2000 / UTM zone 23S',
    value: EPSGCode.SIRGAS_2000_UTM_ZONE_23S,
  },
  {
    label: 'SIRGAS 2000 / UTM zone 24S',
    value: EPSGCode.SIRGAS_2000_UTM_ZONE_24S,
  },
  {
    label: 'TUREF / TM27',
    value: EPSGCode.TUREF_TM27,
  },
];

export const OutputVerticalCRSOptions = [
  {
    label: 'Ellipsoidal',
    value: VerticalCRS.ELLIPSOIDAL,
  },
  {
    label: 'EGM96',
    value: VerticalCRS.EGM96,
  },
  {
    label: 'EGM2008',
    value: VerticalCRS.EGM2008,
  },
  {
    label: 'AHD71',
    value: VerticalCRS.AHD71,
  },
  {
    label: 'CGVD2013',
    value: VerticalCRS.CGVD2013,
  },
  {
    label: 'Baltic 1957',
    value: VerticalCRS.BALTIC_1957,
  },
  {
    label: 'Baltic 1977',
    value: VerticalCRS.BALTIC_1977,
  },
  {
    label: 'Baltic 1982',
    value: VerticalCRS.BALTIC_1982,
  },
  {
    label: 'Baltic 1986',
    value: VerticalCRS.BALTIC_1986,
  },
  {
    label: 'INAGEOID 2020',
    value: VerticalCRS.INAGEOID_2020,
  },
  {
    label: 'MAPGEO2015',
    value: VerticalCRS.MAPGEO2015,
  },
  {
    label: 'IMBITUBA',
    value: VerticalCRS.IMBITUBA,
  },
];

export const AccuracyFields: GeotagSchemaField[] = [
  GeotagSchemaField.HorizontalAccuracy,
  GeotagSchemaField.VerticalAccuracy,
];

export const OmegaPhiKappaRotationAngleFields: GeotagSchemaField[] = [
  GeotagSchemaField.Omega,
  GeotagSchemaField.Phi,
  GeotagSchemaField.Kappa,
];

export const OmegaPhiKappaAccuracyFields: GeotagSchemaField[] = [
  GeotagSchemaField.OmegaAccuracy,
  GeotagSchemaField.PhiAccuracy,
  GeotagSchemaField.KappaAccuracy,
];

export const YawPitchRollRotationAngleFields: GeotagSchemaField[] = [
  GeotagSchemaField.Yaw,
  GeotagSchemaField.Pitch,
  GeotagSchemaField.Roll,
];

export const YawPitchRollAccuracyFields: GeotagSchemaField[] = [
  GeotagSchemaField.YawAccuracy,
  GeotagSchemaField.PitchAccuracy,
  GeotagSchemaField.RollAccuracy,
];

export const Wgs84Fields: GeotagSchemaField[] = [
  GeotagSchemaField.Latitude,
  GeotagSchemaField.Longitude,
  GeotagSchemaField.Altitude,
];

export const Wgs84AccuracyFields: GeotagSchemaField[] = [
  GeotagSchemaField.LatitudeAccuracy,
  GeotagSchemaField.LongitudeAccuracy,
];

export const UtmZoneFields: GeotagSchemaField[] = [
  GeotagSchemaField.Northing,
  GeotagSchemaField.Easting,
  GeotagSchemaField.Altitude,
];

export const UtmZoneAccuracyFields: GeotagSchemaField[] = [
  GeotagSchemaField.NorthingAccuracy,
  GeotagSchemaField.EastingAccuracy,
];

export const EpsgCodeToTextCRSMapping = {
  [EPSGCode.WGS84]: HorizontalCRS.WGS84,
  [EPSGCode.GGRS87_GREEK_GRID]: HorizontalCRS.GGRS87_GREEK_GRID,
  // WGS84 / UTM Northern Hemisphere
  [EPSGCode.WGS84_UTM_ZONE_19N]: HorizontalCRS.WGS84_UTM_ZONE_19N,
  [EPSGCode.WGS84_UTM_ZONE_42]: HorizontalCRS.WGS84_UTM_ZONE_42,
  [EPSGCode.WGS84_UTM_ZONE_43]: HorizontalCRS.WGS84_UTM_ZONE_43,
  [EPSGCode.WGS84_UTM_ZONE_44]: HorizontalCRS.WGS84_UTM_ZONE_44,
  [EPSGCode.WGS84_UTM_ZONE_45]: HorizontalCRS.WGS84_UTM_ZONE_45,
  [EPSGCode.WGS84_UTM_ZONE_46]: HorizontalCRS.WGS84_UTM_ZONE_46,
  [EPSGCode.WGS84_UTM_ZONE_47]: HorizontalCRS.WGS84_UTM_ZONE_47,
  [EPSGCode.WGS84_UTM_ZONE_48]: HorizontalCRS.WGS84_UTM_ZONE_48,
  [EPSGCode.WGS84_UTM_ZONE_49]: HorizontalCRS.WGS84_UTM_ZONE_49,
  [EPSGCode.WGS84_UTM_ZONE_50N]: HorizontalCRS.WGS84_UTM_ZONE_50N,
  [EPSGCode.WGS84_UTM_ZONE_51N]: HorizontalCRS.WGS84_UTM_ZONE_51N,
  [EPSGCode.WGS84_UTM_ZONE_52N]: HorizontalCRS.WGS84_UTM_ZONE_52N,
  [EPSGCode.WGS84_UTM_ZONE_53N]: HorizontalCRS.WGS84_UTM_ZONE_53N,
  [EPSGCode.WGS84_UTM_ZONE_54N]: HorizontalCRS.WGS84_UTM_ZONE_54N,
  // WGS84 / UTM Southern Hemisphere
  [EPSGCode.WGS84_UTM_ZONE_18S]: HorizontalCRS.WGS84_UTM_ZONE_18S,
  [EPSGCode.WGS84_UTM_ZONE_19S]: HorizontalCRS.WGS84_UTM_ZONE_19S,
  [EPSGCode.WGS84_UTM_ZONE_20S]: HorizontalCRS.WGS84_UTM_ZONE_20S,
  [EPSGCode.WGS84_UTM_ZONE_21S]: HorizontalCRS.WGS84_UTM_ZONE_21S,
  [EPSGCode.WGS84_UTM_ZONE_22S]: HorizontalCRS.WGS84_UTM_ZONE_22S,
  [EPSGCode.WGS84_UTM_ZONE_23S]: HorizontalCRS.WGS84_UTM_ZONE_23S,
  [EPSGCode.WGS84_UTM_ZONE_24S]: HorizontalCRS.WGS84_UTM_ZONE_24S,
  [EPSGCode.WGS84_UTM_ZONE_25S]: HorizontalCRS.WGS84_UTM_ZONE_25S,
  [EPSGCode.WGS84_UTM_ZONE_46S]: HorizontalCRS.WGS84_UTM_ZONE_46S,
  [EPSGCode.WGS84_UTM_ZONE_47S]: HorizontalCRS.WGS84_UTM_ZONE_47S,
  [EPSGCode.WGS84_UTM_ZONE_48S]: HorizontalCRS.WGS84_UTM_ZONE_48S,
  [EPSGCode.WGS84_UTM_ZONE_49S]: HorizontalCRS.WGS84_UTM_ZONE_49S,
  [EPSGCode.WGS84_UTM_ZONE_50S]: HorizontalCRS.WGS84_UTM_ZONE_50S,
  [EPSGCode.WGS84_UTM_ZONE_51S]: HorizontalCRS.WGS84_UTM_ZONE_51S,
  [EPSGCode.WGS84_UTM_ZONE_52S]: HorizontalCRS.WGS84_UTM_ZONE_52S,
  [EPSGCode.WGS84_UTM_ZONE_53S]: HorizontalCRS.WGS84_UTM_ZONE_53S,
  [EPSGCode.WGS84_UTM_ZONE_54S]: HorizontalCRS.WGS84_UTM_ZONE_54S,
  // GDA2020 / MGA zones
  [EPSGCode.GDA2020_MGA_ZONE_46]: HorizontalCRS.GDA2020_MGA_ZONE_46,
  [EPSGCode.GDA2020_MGA_ZONE_47]: HorizontalCRS.GDA2020_MGA_ZONE_47,
  [EPSGCode.GDA2020_MGA_ZONE_48]: HorizontalCRS.GDA2020_MGA_ZONE_48,
  [EPSGCode.GDA2020_MGA_ZONE_49]: HorizontalCRS.GDA2020_MGA_ZONE_49,
  [EPSGCode.GDA2020_MGA_ZONE_50]: HorizontalCRS.GDA2020_MGA_ZONE_50,
  [EPSGCode.GDA2020_MGA_ZONE_51]: HorizontalCRS.GDA2020_MGA_ZONE_51,
  [EPSGCode.GDA2020_MGA_ZONE_52]: HorizontalCRS.GDA2020_MGA_ZONE_52,
  [EPSGCode.GDA2020_MGA_ZONE_53]: HorizontalCRS.GDA2020_MGA_ZONE_53,
  [EPSGCode.GDA2020_MGA_ZONE_54]: HorizontalCRS.GDA2020_MGA_ZONE_54,
  [EPSGCode.GDA2020_MGA_ZONE_55]: HorizontalCRS.GDA2020_MGA_ZONE_55,
  [EPSGCode.GDA2020_MGA_ZONE_56]: HorizontalCRS.GDA2020_MGA_ZONE_56,
  [EPSGCode.GDA2020_MGA_ZONE_57]: HorizontalCRS.GDA2020_MGA_ZONE_57,
  [EPSGCode.GDA2020_MGA_ZONE_58]: HorizontalCRS.GDA2020_MGA_ZONE_58,
  // GDA94 / MGA zones
  [EPSGCode.GDA94_MGA_ZONE_46]: HorizontalCRS.GDA94_MGA_ZONE_46,
  [EPSGCode.GDA94_MGA_ZONE_47]: HorizontalCRS.GDA94_MGA_ZONE_47,
  [EPSGCode.GDA94_MGA_ZONE_48]: HorizontalCRS.GDA94_MGA_ZONE_48,
  [EPSGCode.GDA94_MGA_ZONE_49]: HorizontalCRS.GDA94_MGA_ZONE_49,
  [EPSGCode.GDA94_MGA_ZONE_50]: HorizontalCRS.GDA94_MGA_ZONE_50,
  [EPSGCode.GDA94_MGA_ZONE_51]: HorizontalCRS.GDA94_MGA_ZONE_51,
  [EPSGCode.GDA94_MGA_ZONE_52]: HorizontalCRS.GDA94_MGA_ZONE_52,
  [EPSGCode.GDA94_MGA_ZONE_53]: HorizontalCRS.GDA94_MGA_ZONE_53,
  [EPSGCode.GDA94_MGA_ZONE_54]: HorizontalCRS.GDA94_MGA_ZONE_54,
  [EPSGCode.GDA94_MGA_ZONE_55]: HorizontalCRS.GDA94_MGA_ZONE_55,
  [EPSGCode.GDA94_MGA_ZONE_56]: HorizontalCRS.GDA94_MGA_ZONE_56,
  [EPSGCode.GDA94_MGA_ZONE_57]: HorizontalCRS.GDA94_MGA_ZONE_57,
  [EPSGCode.GDA94_MGA_ZONE_58]: HorizontalCRS.GDA94_MGA_ZONE_58,
  // Other CRS
  [EPSGCode.ARC_1950_UTM_ZONE_35S]: HorizontalCRS.ARC_1950_UTM_ZONE_35S,
  [EPSGCode.NAD83_2011_WISCONSIN_SOUTH_FTUS]:
    HorizontalCRS.NAD83_2011_WISCONSIN_SOUTH_FTUS,
  [EPSGCode.NAD83_CSRS_UTM_ZONE_19N]: HorizontalCRS.NAD83_CSRS_UTM_ZONE_19N,
  [EPSGCode.SIRGAS_2000_UTM_ZONE_14N]: HorizontalCRS.SIRGAS_2000_UTM_ZONE_14N,
  [EPSGCode.SIRGAS_2000_UTM_ZONE_23S]: HorizontalCRS.SIRGAS_2000_UTM_ZONE_23S,
  [EPSGCode.SIRGAS_2000_UTM_ZONE_24S]: HorizontalCRS.SIRGAS_2000_UTM_ZONE_24S,
  [EPSGCode.TUREF_TM27]: HorizontalCRS.TUREF_TM27,
};

export const TextCRSToEPSGCodeMapping = {
  [HorizontalCRS.WGS84]: EPSGCode.WGS84,
  [HorizontalCRS.GGRS87_GREEK_GRID]: EPSGCode.GGRS87_GREEK_GRID,
  // WGS84 / UTM Northern Hemisphere.
  [HorizontalCRS.WGS84_UTM_ZONE_19N]: EPSGCode.WGS84_UTM_ZONE_19N,
  [HorizontalCRS.WGS84_UTM_ZONE_42]: EPSGCode.WGS84_UTM_ZONE_42,
  [HorizontalCRS.WGS84_UTM_ZONE_43]: EPSGCode.WGS84_UTM_ZONE_43,
  [HorizontalCRS.WGS84_UTM_ZONE_44]: EPSGCode.WGS84_UTM_ZONE_44,
  [HorizontalCRS.WGS84_UTM_ZONE_45]: EPSGCode.WGS84_UTM_ZONE_45,
  [HorizontalCRS.WGS84_UTM_ZONE_46]: EPSGCode.WGS84_UTM_ZONE_46,
  [HorizontalCRS.WGS84_UTM_ZONE_47]: EPSGCode.WGS84_UTM_ZONE_47,
  [HorizontalCRS.WGS84_UTM_ZONE_48]: EPSGCode.WGS84_UTM_ZONE_48,
  [HorizontalCRS.WGS84_UTM_ZONE_49]: EPSGCode.WGS84_UTM_ZONE_49,
  [HorizontalCRS.WGS84_UTM_ZONE_50N]: EPSGCode.WGS84_UTM_ZONE_50N,
  [HorizontalCRS.WGS84_UTM_ZONE_51N]: EPSGCode.WGS84_UTM_ZONE_51N,
  [HorizontalCRS.WGS84_UTM_ZONE_52N]: EPSGCode.WGS84_UTM_ZONE_52N,
  [HorizontalCRS.WGS84_UTM_ZONE_53N]: EPSGCode.WGS84_UTM_ZONE_53N,
  [HorizontalCRS.WGS84_UTM_ZONE_54N]: EPSGCode.WGS84_UTM_ZONE_54N,

  // WGS84 / UTM Southern Hemisphere.
  [HorizontalCRS.WGS84_UTM_ZONE_18S]: EPSGCode.WGS84_UTM_ZONE_18S,
  [HorizontalCRS.WGS84_UTM_ZONE_19S]: EPSGCode.WGS84_UTM_ZONE_19S,
  [HorizontalCRS.WGS84_UTM_ZONE_20S]: EPSGCode.WGS84_UTM_ZONE_20S,
  [HorizontalCRS.WGS84_UTM_ZONE_21S]: EPSGCode.WGS84_UTM_ZONE_21S,
  [HorizontalCRS.WGS84_UTM_ZONE_22S]: EPSGCode.WGS84_UTM_ZONE_22S,
  [HorizontalCRS.WGS84_UTM_ZONE_23S]: EPSGCode.WGS84_UTM_ZONE_23S,
  [HorizontalCRS.WGS84_UTM_ZONE_24S]: EPSGCode.WGS84_UTM_ZONE_24S,
  [HorizontalCRS.WGS84_UTM_ZONE_25S]: EPSGCode.WGS84_UTM_ZONE_25S,
  [HorizontalCRS.WGS84_UTM_ZONE_46S]: EPSGCode.WGS84_UTM_ZONE_46S,
  [HorizontalCRS.WGS84_UTM_ZONE_47S]: EPSGCode.WGS84_UTM_ZONE_47S,
  [HorizontalCRS.WGS84_UTM_ZONE_48S]: EPSGCode.WGS84_UTM_ZONE_48S,
  [HorizontalCRS.WGS84_UTM_ZONE_49S]: EPSGCode.WGS84_UTM_ZONE_49S,
  [HorizontalCRS.WGS84_UTM_ZONE_50S]: EPSGCode.WGS84_UTM_ZONE_50S,
  [HorizontalCRS.WGS84_UTM_ZONE_51S]: EPSGCode.WGS84_UTM_ZONE_51S,
  [HorizontalCRS.WGS84_UTM_ZONE_52S]: EPSGCode.WGS84_UTM_ZONE_52S,
  [HorizontalCRS.WGS84_UTM_ZONE_53S]: EPSGCode.WGS84_UTM_ZONE_53S,
  [HorizontalCRS.WGS84_UTM_ZONE_54S]: EPSGCode.WGS84_UTM_ZONE_54S,

  // GDA2020 / MGA zones.
  [HorizontalCRS.GDA2020_MGA_ZONE_46]: EPSGCode.GDA2020_MGA_ZONE_46,
  [HorizontalCRS.GDA2020_MGA_ZONE_47]: EPSGCode.GDA2020_MGA_ZONE_47,
  [HorizontalCRS.GDA2020_MGA_ZONE_48]: EPSGCode.GDA2020_MGA_ZONE_48,
  [HorizontalCRS.GDA2020_MGA_ZONE_49]: EPSGCode.GDA2020_MGA_ZONE_49,
  [HorizontalCRS.GDA2020_MGA_ZONE_50]: EPSGCode.GDA2020_MGA_ZONE_50,
  [HorizontalCRS.GDA2020_MGA_ZONE_51]: EPSGCode.GDA2020_MGA_ZONE_51,
  [HorizontalCRS.GDA2020_MGA_ZONE_52]: EPSGCode.GDA2020_MGA_ZONE_52,
  [HorizontalCRS.GDA2020_MGA_ZONE_53]: EPSGCode.GDA2020_MGA_ZONE_53,
  [HorizontalCRS.GDA2020_MGA_ZONE_54]: EPSGCode.GDA2020_MGA_ZONE_54,
  [HorizontalCRS.GDA2020_MGA_ZONE_55]: EPSGCode.GDA2020_MGA_ZONE_55,
  [HorizontalCRS.GDA2020_MGA_ZONE_56]: EPSGCode.GDA2020_MGA_ZONE_56,
  [HorizontalCRS.GDA2020_MGA_ZONE_57]: EPSGCode.GDA2020_MGA_ZONE_57,
  [HorizontalCRS.GDA2020_MGA_ZONE_58]: EPSGCode.GDA2020_MGA_ZONE_58,

  // GDA94 / MGA zones.
  [HorizontalCRS.GDA94_MGA_ZONE_46]: EPSGCode.GDA94_MGA_ZONE_46,
  [HorizontalCRS.GDA94_MGA_ZONE_47]: EPSGCode.GDA94_MGA_ZONE_47,
  [HorizontalCRS.GDA94_MGA_ZONE_48]: EPSGCode.GDA94_MGA_ZONE_48,
  [HorizontalCRS.GDA94_MGA_ZONE_49]: EPSGCode.GDA94_MGA_ZONE_49,
  [HorizontalCRS.GDA94_MGA_ZONE_50]: EPSGCode.GDA94_MGA_ZONE_50,
  [HorizontalCRS.GDA94_MGA_ZONE_51]: EPSGCode.GDA94_MGA_ZONE_51,
  [HorizontalCRS.GDA94_MGA_ZONE_52]: EPSGCode.GDA94_MGA_ZONE_52,
  [HorizontalCRS.GDA94_MGA_ZONE_53]: EPSGCode.GDA94_MGA_ZONE_53,
  [HorizontalCRS.GDA94_MGA_ZONE_54]: EPSGCode.GDA94_MGA_ZONE_54,
  [HorizontalCRS.GDA94_MGA_ZONE_55]: EPSGCode.GDA94_MGA_ZONE_55,
  [HorizontalCRS.GDA94_MGA_ZONE_56]: EPSGCode.GDA94_MGA_ZONE_56,
  [HorizontalCRS.GDA94_MGA_ZONE_57]: EPSGCode.GDA94_MGA_ZONE_57,
  [HorizontalCRS.GDA94_MGA_ZONE_58]: EPSGCode.GDA94_MGA_ZONE_58,

  // Other CRS.
  [HorizontalCRS.ARC_1950_UTM_ZONE_35S]: EPSGCode.ARC_1950_UTM_ZONE_35S,
  [HorizontalCRS.NAD83_2011_WISCONSIN_SOUTH_FTUS]:
    EPSGCode.NAD83_2011_WISCONSIN_SOUTH_FTUS,
  [HorizontalCRS.NAD83_CSRS_UTM_ZONE_19N]: EPSGCode.NAD83_CSRS_UTM_ZONE_19N,
  [HorizontalCRS.SIRGAS_2000_UTM_ZONE_14N]: EPSGCode.SIRGAS_2000_UTM_ZONE_14N,
  [HorizontalCRS.SIRGAS_2000_UTM_ZONE_23S]: EPSGCode.SIRGAS_2000_UTM_ZONE_23S,
  [HorizontalCRS.SIRGAS_2000_UTM_ZONE_24S]: EPSGCode.SIRGAS_2000_UTM_ZONE_24S,
  [HorizontalCRS.TUREF_TM27]: EPSGCode.TUREF_TM27,
};

export const GcpTypeToLabel = {
  [GCPType.CONTROLPOINT]: GCPTypeLabel.GCP,
  [GCPType.CHECKPOINT]: GCPTypeLabel.CHECKPOINT,
};

export const GcpLabelToType = {
  ['GCP']: GCPType.CONTROLPOINT,
  ['Checkpoint']: GCPType.CHECKPOINT,
};

export const noDataViewText = {
  Images: {
    heading: "You've not uploaded any Images yet",
    subHeading: 'Do you want to upload?',
    btnIcon: IconIdentifier.Upload,
    btnText: 'Upload Images',
  },
  Geotags: {
    heading: "You've not uploaded any Geotags yet",
    subHeading: 'Do you want to upload?',
    btnIcon: IconIdentifier.Upload,
    btnText: 'Upload Geotags',
  },
  Tasks: {
    heading: "You've not added any Tasks yet",
    subHeading: 'Do you want to add one?',
    btnIcon: IconIdentifier.Plus,
    btnText: 'Create Task',
  },
};

export enum ExifOrientationNumber {
  One = 1,
  Three = 3,
  Six = 6,
  Eight = 8,
}

enum ImageOrientationTypeSlug {
  HorizontalNormal = 'horizontal_normal',
  RotatedBy180 = 'rotated_180',
  RotatedCWBy90 = 'rotated_90_cw',
  RotatedCCWBy90 = 'rotated_90_ccw',
}

export const ExifOrientationNumberToTypeMapping = {
  [ImageOrientationTypeSlug.HorizontalNormal]: ExifOrientationNumber.One,
  [ImageOrientationTypeSlug.RotatedBy180]: ExifOrientationNumber.Three,
  [ImageOrientationTypeSlug.RotatedCWBy90]: ExifOrientationNumber.Six,
  [ImageOrientationTypeSlug.RotatedCCWBy90]: ExifOrientationNumber.Eight,
};

export const FinalStateTaskStatus: Array<string> = [
  ProcessingStatus.Error,
  ProcessingStatus.Cancelled,
  ProcessingStatus.Completed,
];

export const CoordinatesRange = {
  LongitudeMaxRange: 180,
  LongitudeMinRange: -180,
  LatitudeMaxRange: 90,
  LatitudeMinRange: -90,
  EastingMaxRange: 1000000,
  EastingMinRange: 0,
  NorthingMaxRange: 10000000,
  NorthingMinRange: 0,
  AltitudeMaxRange: 10000,
  AltitudeMinRange: -100,
};

export const ProcessingStages: EndProcessingSelectOption[] = [
  {
    value: ProcessingStagesValue.AlignPhotos,
    stage: 1,
    label: (
      <div className="processing-stage-dropdown">
        <div>{'Align Photos'}</div>
        <Pill className="stage__dropdown-pill" variant={PillVariant.Success}>
          Stage 1
        </Pill>
      </div>
    ),
  },
  {
    value: ProcessingStagesValue.GeneratePointCloud,
    stage: 2,
    label: (
      <div className="processing-stage-dropdown">
        <div>{'Generate Point Cloud'}</div>
        <Pill className="stage__dropdown-pill" variant={PillVariant.Success}>
          Stage 2{' '}
        </Pill>
      </div>
    ),
  },
  {
    value: ProcessingStagesValue.GenerateOrthomosaic,
    stage: 3,
    label: (
      <div className="processing-stage-dropdown">
        <div>{'Generate Orthomosaic'}</div>
        <Pill className="stage__dropdown-pill" variant={PillVariant.Success}>
          Stage 3
        </Pill>
      </div>
    ),
  },
];

export const EndStageToIndexMapping = {
  [ProcessingStagesValue.GenerateOrthomosaic]: ProcessingStages[2],
  [ProcessingStagesValue.GeneratePointCloud]: ProcessingStages[1],
  [ProcessingStagesValue.AlignPhotos]: ProcessingStages[0],
};

export const FinalMergingStates: Array<string> = [
  ProcessingStatus.Error,
  ProcessingStatus.Cancelled,
  ProcessingStatus.Completed,
];

export const DatasetAssetTypeLabel = {
  [DatasetAssetTypeWithBaseData.TiePoints]: 'Tie Points',
  [DatasetAssetTypeWithBaseData.DenseCloud]: 'Dense Clouds',
  [DatasetAssetTypeWithBaseData.DEM]: 'DEMs',
  [DatasetAssetTypeWithBaseData.Orthomosaic]: 'Orthomosaics',
  [DatasetAssetTypeWithBaseData.BaseData]: 'Base Data',
};
